var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-list"},[_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.steps),function(description,index){return _c('step',{key:index,attrs:{"indicator":index+1,"description":description}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }